import { render, staticRenderFns } from "./PagePerformanceReviewSubmitEdit.vue?vue&type=template&id=3f067c4e&"
import script from "./PagePerformanceReviewSubmitEdit.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviewSubmitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports